<template>
  <div>
    <Modal
      v-model="isVisible"
      title="导入资料"
      :mask-closable="false"
      class-name="edit-modal-box"
    >
      <div class="edit-modal-contain">
        <Form
          ref="editModalContain"
          :model="formData"
          :rules="ruleValidate"
          :label-width="180"
        >
          <FormItem label="选择导入文件：">
            <div class="form-item-line">
              <dytUpload
                ref="editUpload"
                file-name="file"
                :action="uploadPath"
                :data="uploadData"
                :before-upload="beforeUpload"
                :headers="uploadHeader"
                :on-success="uploadSuccess"
                :on-error="uploadError"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :show-upload-list="false"
              >
                <Button icon="ios-cloud-upload-outline" type="primary" class="form-upload-file">请选择文件</Button>
              </dytUpload>
              <div class="download-file" @click="downloadTemplate">下载模板</div>
            </div>

          </FormItem>
          <FormItem label="文件：">
            <span>{{ `${$common.isEmpty(file) ? '' : file.name || ''}` }}</span>
          </FormItem>
          <FormItem label="导入的平台SKU一致时：" prop="importType">
            <RadioGroup v-model="formData.importType">
              <Radio :label="1">覆盖</Radio>
              <Radio :label="0">忽略</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="isVisible = false">取 消</Button>
        <Button
          type="primary"
          @click="saveThirdparty"
          :disabled="modalLoading"
        >确 定</Button>
      </div>
      <Spin fix v-if="modalLoading">正在处理数据中....</Spin>
    </Modal>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: "importThirdPartyTag",
  components: {},
  props: {
    modelVisible: {
      type: Boolean,
      default: false
    },
    moduleData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      modalLoading: false,
      confirmUpload: false,
      file: null,
      // 表单默认数据
      formData: {
        platformId: '', // 平台id
        saleAccountId: '', // 店铺id
        importType: 1, // 导入类型（0：忽略 1：覆盖）
      },
      // 表单验证
      ruleValidate: {},
      isVisible: false,
      uploadPath: api.importThirdPartyTag
    };
  },
  watch: {
    modelVisible (newVal) {
      if (newVal) this.open();
    },
    isVisible (newVal) {
      this.$emit('update:modelVisible', newVal);
      !newVal && this.closeModal();
    }
  },
  computed: {
    // 上传组件头部信息
    uploadHeader () {
      return {
        ...this.$store.getters.erpRequestHeaders,
        ...this.$store.getters.dytRequestHeaders
      }
    },
    platformId () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.platformId)) return '';
      return this.moduleData.platformId;
    },
    // 上传的数据
    uploadData () {
      return this.formData;
    }
  },
  methods: {
    // 打开窗口
    open () {
      this.$nextTick(() => {
        this.initData();
        this.$nextTick(() => {
          this.isVisible = this.modelVisible;
        })
      })
    },
    // 关闭弹窗
    closeModal () {
      this.modalLoading = false;
      this.isVisible = false;
      this.file = null;
      this.$nextTick(() => {
        this.$refs.editModalContain && this.$refs.editModalContain.resetFields();
        this.$nextTick(() => {
          this.$refs.editModalContain && this.$refs.editModalContain.resetFields();
        })
      })
    },
    initData () {
      this.modalLoading = true;
      if (!this.$common.isEmpty(this.moduleData)) {
        Object.keys(this.formData).forEach(key => {
          if (!this.$common.isUndefined(this.moduleData[key])) {
            this.formData[key] = this.moduleData[key];
          }
        })
      }
      this.$common.promiseAll([]).then((resArr) => {
        // console.log(resArr);
      }).finally(() => {
        this.modalLoading = false;
      })
    },
    // 文件上传前
    beforeUpload(file) {
      if (!file) {
        this.$Message.error('请上传文件!');
        return false;
      }
      if (['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
        this.file = file;
        return this.confirmUpload;
      }
      this.file = null;
      this.$Message.error('文件格式不对，请上传图片文件');
      return false;
    },
    // 文件上传成功
    uploadSuccess (response, file, fileList) {
      this.file = null;
      setTimeout(() => {
        this.$Message.success('导入资料成功');
        this.isVisible = false;
        this.confirmUpload = false;
        this.modalLoading = false;
        // 保存成功后刷新父级列表
        this.$emit('refreshParentPage', false);
      }, 1000)
    },
    // 文件上传失败
    uploadError (error, file, fileList) {
      this.$Message.error('导入资料失败！');
      this.confirmUpload = false;
      this.modalLoading = false;
      console.error(error);
    },
    // 保存
    saveThirdparty () {
      if (this.modalLoading) return;
      this.confirmUpload = true;
      this.modalLoading = true;
      this.$refs.editUpload.upload(this.file);
    },
    // 下载模板
    async downloadTemplate() {
      let url = await this.getTemplateFromApi();
      if (!url) {
        this.$Message.error('下载模板路径丢失~');
        return;
      }
      const fileUrl = `${window.location.origin}/product-service/filenode/s${url}`;
      this.$common.downloadFile(fileUrl);
    },
    getTemplateFromApi() {
      return new Promise(resolve => {
        this.axios.get(`${api.thirdTemplate}`, {
          params: {
            platformId: this.platformId
          }
        }).then(res => {
          if (res.data.code === 0 && !this.$common.isEmpty(res.data.datas)) {
            resolve(res.data.datas);
          } else {
            resolve(null);
          }
        }).catch(() => {
          resolve(null);
        })
      })
    },
  }
};
</script>
<style lang="less" scoped>
:deep(.edit-modal-box){
  .ivu-modal{
    top: 60px;
    width: 80% !important;
    max-width: 700px;
    min-width: 400px;
    .ivu-modal-body{
      max-height: calc(100vh - 200px);
    }
  }
  .ivu-modal-body{
    padding: 0
  }
  .ivu-input[disabled] {
    color: #515a6e;
  }
}
.form-item-line{
  display: flex;
  padding-right: 30px;
  justify-content: space-between;
}
.download-file{
  color: #2d8cf0;
  text-decoration: underline;
  cursor: pointer;
}
.edit-modal-contain{
  position: relative;
  max-height: calc(100vh - 200px);
  padding: 16px 16px 0px 16px;
  overflow: auto;
}

.ivu-modal-body {
  position: relative;
  .ivu-modal-confirm-footer{
    position: sticky;
    bottom: -16px;
    padding: 20px 0;
    text-align: right;
    background: #fff;
  }
}
</style>
